import axios from 'axios';
import { BFFbaseURL } from '../../config';

let eventSource;

export async function checkIfClaimIsAssisted(gwclaimId, setIsAssisted) {
  const response = await axios.get(`${BFFbaseURL}/claimAssisted/${gwclaimId}`);
  if (response.data === true) {
    setIsAssisted(true);
  }
}

export function claimAssistedListener(gwclaimId, setIsAssisted) {
  eventSource = new EventSource(`${BFFbaseURL}/claimStatus/${gwclaimId}`, { withCredentials: true });
  eventSource.onmessage = (e) => {
    if (JSON.parse(e.data).assisted) {
      setIsAssisted(true);
    }
  };
  eventSource.onerror = () => {
    eventSource.close();
  };
}

export function closeClaimAssistedListener() {
  eventSource.close();
}
